import { makeFupIcon } from './FupIconFactory';
export default makeFupIcon('DEMUX4');
